import { Component, OnInit } from '@angular/core';
import { CommonApiService } from '../../common-api.service';
import { SnackbarService } from '../../snackbar.service';
import { MODULE_ACCESS_OPTIONS } from '../module-access.constants';
import { UserRole } from '../userrole/userrole.interface';

@Component({
  selector: 'app-access-control',
  templateUrl: './access-control.component.html',
  styleUrls: ['./access-control.component.css'],
})
export class AccessControlComponent implements OnInit {
  constructor(
    private api: CommonApiService,
    private snackbar: SnackbarService,
  ) {}

  modules = MODULE_ACCESS_OPTIONS;
  showContent = false;

  allRoles: UserRole[] = [];
  filteredRoles: UserRole[] = [];
  selectedRole: UserRole;
  modules_selected: string[] = [];

  ngOnInit(): void {
    this.api.getAll('userrole').subscribe((res) => {
      this.allRoles = res;
      this.filteredRoles = res;
    });
  }

  save(): void {
    const data = {
      userrole_id: this.selectedRole.id,
      modules: this.modules_selected,
    };
    this.api.callRoute('userrole', '/access/update', data).subscribe((res: any) => {
      if (res) {
        this.snackbar.success('Access permissions saved successfully');
      }
    });
  }

  isModuleEnabled(moduleName: string): boolean {
    return this.modules_selected.includes(moduleName);
  }

  onToggleModule(moduleName: string, event: any): void {
    if (event.checked) {
      if (!this.modules_selected.includes(moduleName)) {
        this.modules_selected.push(moduleName);
      }
    } else {
      this.modules_selected = this.modules_selected.filter((m) => m !== moduleName);
    }
  }

  toggleAll(event: any): void {
    if (event.checked) {
      this.modules_selected = this.modules.map((m) => m.name);
    } else {
      this.modules_selected = [];
    }
  }

  get allSelected(): boolean {
    return this.modules.length > 0 && this.modules_selected.length === this.modules.length;
  }

  get someSelected(): boolean {
    return this.modules_selected.length > 0 && this.modules_selected.length < this.modules.length;
  }

  onRoleChange(): void {
    this.showContent = true;
    if (this.selectedRole.access) {
      this.modules_selected = [...this.selectedRole.access];
    } else {
      this.selectedRole.access = [];
      this.modules_selected = [];
    }
  }

  onRoleKey(event: Event): void {
    const value = (event.target as HTMLInputElement).value;
    this.filteredRoles = this.searchRoles(value);
  }

  searchRoles(value: string): UserRole[] {
    const filter = value.toLowerCase();
    return this.allRoles.filter((option) => option.name.toLowerCase().includes(filter));
  }
}

